import { PdfBrandConfig } from '@common/types';
import { compact } from 'lodash';
// eslint-disable-next-line import/no-unresolved
import { Content } from 'pdfmake/interfaces';
import { convertImageToBase64, PdfContentProps } from './pdf-content-creator';

interface PdfCoverProps {
  title: string;
  subtitle1: string;
  subtitle2?: string;
  subtitle3?: string;
  brandConfig: PdfBrandConfig;
}
export const getPdfCover = async ({
  title,
  subtitle1,
  subtitle2,
  subtitle3,
  brandConfig,
}: PdfCoverProps): Promise<PdfContentProps> => {
  const backgroundImage = brandConfig.pdfCoverBgImage ? await convertImageToBase64(brandConfig.pdfCoverBgImage) : '';
  const logoImage = brandConfig.logoImage ? await convertImageToBase64(brandConfig.logoImage) : '';

  const bgImage: Content | null = backgroundImage
    ? {
        image: `data:image/png;base64,${backgroundImage}`,
        absolutePosition: { x: 0, y: 0 },
        width: 595,
        height: 842,
      }
    : null;

  const logo: Content | null = logoImage
    ? {
        image: `data:image/png;base64,${logoImage}`,
        width: 160, // Change this value based on your logo size
        alignment: 'left',
        margin: brandConfig.style.logoStyle.margin,
      }
    : null;

  const titleText: Content = {
    text: title,
    alignment: 'left',
    font: 'Inter', // Make sure this matches your registered custom font name
    fontSize: 16,
    margin: [0, 10, 0, 0], // Adjust spacing as needed
    color: brandConfig.coverLetterTextColor,
    style: 'preparedTextBold',
  };

  const coverageLinesText: Content = {
    text: subtitle1,
    alignment: 'left',
    font: 'Inter', // Make sure this matches your registered custom font name
    fontSize: 12,
    margin: [0, 0, 0, 0], // Adjust spacing as needed
    color: brandConfig.coverLetterTextColor,
    style: 'preparedText',
  };

  const insuredText: Content | undefined = subtitle2
    ? {
        text: subtitle2,
        alignment: 'left',
        font: 'Inter', // Make sure this matches your registered custom font name
        fontSize: 12,
        margin: [0, 0, 0, 0], // Adjust spacing as needed
        color: brandConfig.coverLetterTextColor,
        style: 'preparedText',
      }
    : undefined;

  const deliveryDateText: Content | undefined = subtitle3
    ? {
        text: subtitle3,
        alignment: 'left',
        font: 'Inter', // Make sure this matches your registered custom font name
        fontSize: 12,
        margin: [0, 0, 0, 0], // Adjust spacing as needed
        color: brandConfig.coverLetterTextColor,
        style: 'preparedText',
      }
    : undefined;

  return {
    header: () => [],
    footer() {
      return [
        {
          text: brandConfig.coverFooterText,
          alignment: 'center',
          font: 'Inter', // custom font; ensure it's registered
          fontSize: 12,
          color: brandConfig.coverLetterTextColor,
          margin: [0, 20, 0, 0], // negative top margin to move text over the image
        },
      ];
    },
    content: compact([bgImage, logo, titleText, coverageLinesText, insuredText, deliveryDateText]),
    brandConfig,
  };
};
